var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 28,
    viewBox: "0 0 23 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8978 10.597V7.73432C17.8978 4.38365 15.1805 1.66632 11.8298 1.66632C8.47915 1.65165 5.75115 4.35565 5.73648 7.70765V7.73432V10.597",
    stroke: "#C70039",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9109 26.3326H6.7229C3.9309 26.3326 1.6669 24.07 1.6669 21.2766V15.558C1.6669 12.7646 3.9309 10.502 6.7229 10.502H16.9109C19.7029 10.502 21.9669 12.7646 21.9669 15.558V21.2766C21.9669 24.07 19.7029 26.3326 16.9109 26.3326Z",
    stroke: "#C70039",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8172 16.9368V19.8981",
    stroke: "#C70039",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.b82fc50e1d5af5c317027dddc2131dd5.svg";
export { ForwardRef as ReactComponent };